/** LOCALE TH */
import common from 'locales/plus/th/common.json'
import validation from 'locales/plus/th/validation.json'
import login from 'locales/plus/th/login.json'
import menus from 'locales/plus/th/menu.json'
import home from 'locales/plus/th/home/home.json'
import breadcrumb from 'locales/plus/th/breadcrumb.json'
import clinicManagement from 'locales/plus/th/admin/clinic-management.json'
import custom from 'locales/plus/th/admin/custom.json'
import labOrder from 'locales/plus/th/lab-order.json'
import historyTreatment from 'locales/plus/th/historyTreatment/historyTreatment.json'
import dashboard from 'locales/plus/th/dashboard.json'
import retrospectiveOrder from 'locales/plus/th/retrospectiveOrder.json'
import retrospectiveEdit from 'locales/plus/th/retrospectiveEdit.json'
import confirmAppointment from 'locales/plus/th/confirmAppointment.json'
import report from 'locales/plus/th/report.json'
import Warehouses from 'locales/plus/th/warehouses/warehouses.locale'
import { Counter } from 'locales/plus/th/counter/counter.locale'
import { Treatment } from 'locales/plus/th/dentist/treatment.locale'
import { Payment } from 'locales/plus/th/finance/payment.locale'
import { Application } from 'locales/plus/th/application/application.locale'
import { Setting } from 'locales/plus/th/setting/setting.locale'
import update from 'locales/plus/th/update/updatepage.json'
import {ApprovalTH} from 'locales/plus/th/approval/approval.locale'
import  memberTH  from 'locales/plus/th/member.json'
/** LOCALE EN */

import commonEN from 'locales/plus/en/common.json'
import validationEN from 'locales/plus/en/validation.json'
import loginEN from 'locales/plus/en/login.json'
import menusEN from 'locales/plus/en/menu.json'
import homeEN from 'locales/plus/en/home/home.json'
import breadcrumbEN from 'locales/plus/en/breadcrumb.json'
import clinicManagementEN from 'locales/plus/en/admin/clinic-management.json'
import customEN from 'locales/plus/en/admin/custom.json'
import labOrderEN from 'locales/plus/en/lab-order.json'
import historyTreatmentEN from 'locales/plus/en/historyTreatment/historyTreatment.json'
import dashboardEN from 'locales/plus/en/dashboard.json'
import retrospectiveOrderEN from 'locales/plus/en/retrospectiveOrder.json'
import retrospectiveEditEN from 'locales/plus/en/retrospectiveEdit.json'
import confirmAppointmentEN from 'locales/plus/en/confirmAppointment.json'
import reportEN from 'locales/plus/en/report.json'
import WarehousesEN from 'locales/plus/en/warehouses/warehouses.locale'
import { CounterEN } from 'locales/plus/en/counter/counter.locale'
import { TreatmentEN } from 'locales/plus/en/dentist/treatment.locale'
import { PaymentEN } from 'locales/plus/en/finance/payment.locale'
import { ApplicationEN } from 'locales/plus/en/application/application.locale'
import { SettingEN } from 'locales/plus/en/setting/setting.locale'
import updateEN from 'locales/plus/en/update/updatepage.json'
import checkin from 'locales/plus/th/check-in.json'
import checkinEN from 'locales/plus/en/check-in.json'
import material from 'locales/plus/th/warehouses/material.json'
import materialEn from 'locales/plus/en/warehouses/material.json'
import {ApprovalEN} from 'locales/plus/en/approval/approval.locale'
import  memberEN  from 'locales/plus/en/member.json'
import {crmManageTH} from 'locales/plus/th/crmManage/crmManage.locale'
import {crmManageEN} from 'locales/plus/en/crmManage/crmManage.locale'

export const clinicLocaleTH = {
  ...common,
  ...validation,
  ...login,
  ...menus,
  ...home,
  ...breadcrumb,
  ...labOrder,
  ...clinicManagement,
  ...custom,
  ...historyTreatment,
  ...dashboard,
  ...retrospectiveOrder,
  ...retrospectiveEdit,
  ...confirmAppointment,
  ...report,
  ...Counter,
  ...Treatment,
  ...Payment,
  ...Warehouses,
  ...Setting,
  ...Application,
  ...update,
  ...checkin,
  ...material,
  ...ApprovalTH,
  ...memberTH,
  ...crmManageTH
}

export const clinicLocaleEN = {
  ...commonEN,
  ...validationEN,
  ...loginEN,
  ...menusEN,
  ...homeEN,
  ...breadcrumbEN,
  ...labOrderEN,
  ...clinicManagementEN,
  ...customEN,
  ...historyTreatmentEN,
  ...dashboardEN,
  ...retrospectiveOrderEN,
  ...retrospectiveEditEN,
  ...confirmAppointmentEN,
  ...reportEN,
  ...CounterEN,
  ...TreatmentEN,
  ...PaymentEN,
  ...WarehousesEN,
  ...SettingEN,
  ...ApplicationEN,
  ...updateEN,
  ...checkinEN,
  ...materialEn,
  ...ApprovalEN,
  ...memberEN,
  ...crmManageEN
}
